import { render, staticRenderFns } from "./CostType.vue?vue&type=template&id=40d53e3d&scoped=true&"
import script from "./CostType.vue?vue&type=script&lang=js&"
export * from "./CostType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d53e3d",
  null
  
)

component.options.__file = "CostType.vue"
export default component.exports